<ion-card class="notification-card" [class.read]="notification?.read">
  <ion-card-content>
    <div>
      <div class="flex-title mb-6">
        <div>
          <ion-label
            [attr.data-cy]="
              'notification-' + notification?.alertBatchId + '-title'
            "
            class="notification-title"
            >{{ messageTitle }}</ion-label
          >
        </div>
        <div class="flex-title">
          <ion-label
            [attr.data-cy]="
              'notification-' + notification?.alertBatchId + '-timestamp'
            "
            class="notification-subtitle"
            >{{ notification?.addDtm | date: 'MM/dd/YYYY':'GMT' }}</ion-label
          >
          <ion-icon
            *ngIf="!notification?.read"
            [attr.data-cy]="
              'notification-' + notification?.alertBatchId + '-read-icon'
            "
            class="notification-read-icon"
            color="primary"
            name="ellipse"
          ></ion-icon>
        </div>
      </div>
      <div class="flex-customer mb-8">
        <div>
          <ion-label
            [attr.data-cy]="
              'notification-' + notification?.alertBatchId + '-customer-name'
            "
            class="notification-subtitle"
            >{{ notification?.customerName | titlecase }}</ion-label
          >
        </div>
        <div>
          <ion-label
            [attr.data-cy]="
              'notification-' + notification?.alertBatchId + '-customer-number'
            "
            class="notification-subtitle"
            >(ID {{ notification?.customerNumber }})</ion-label
          >
        </div>
      </div>
      <div class="mb-8">
        <ion-label
          [attr.data-cy]="
            'notification-' + notification?.alertBatchId + '-message'
          "
          class="notification-message"
          [innerText]="messageBody"
        ></ion-label>
      </div>
      <div
        [attr.data-cy]="'notification-' + notification?.alertBatchId + '-link'"
      >
        <ion-label *ngIf="deeplink" class="notification-link">{{
          deeplink
        }}</ion-label>
      </div>
    </div>
  </ion-card-content>
</ion-card>
